// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-quote-button{margin-left:20px;@media screen and (max-width:600px){margin-left:0!important}}", ""]);
// Exports
module.exports = exports;
